import { render, staticRenderFns } from "./_Popper.vue?vue&type=template&id=30bbaf09"
import script from "./_Popper.vue?vue&type=script&lang=js"
export * from "./_Popper.vue?vue&type=script&lang=js"
import style0 from "./_Popper.vue?vue&type=style&index=0&id=30bbaf09&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports